import { getPortByTouchstone } from "../../helper/getPortByTouchstone";
import { SPICE, TOUCHSTONE } from "../constants";
import { getPkgSpiceModelList } from "../library";
import { SCHEMATIC, SPICE as PRE_LAYOUT_SPICE } from "../prelayout/constants";

async function preLayoutErrorCheck(preLayoutData, decapList, Options) {
  if (!preLayoutData) {
    return []
  }
  const { content, name, preLayoutType = SCHEMATIC } = preLayoutData;
  const { useHspice = false } = Options || {}
  let errors = [];
  if (preLayoutType === PRE_LAYOUT_SPICE) {
    if (!useHspice) {
      const { model = {} } = content
      errors = await preLayoutModelErrorCheck(model)
    }
    return errors
  }
  const { balls, decapGroups, powerNets } = content;
  for (let powerNet of powerNets) {
    if (!balls[powerNet]) {
      errors.push(`[Pre-Layout][${name}][${powerNet}][Ball] Not set RLC.`)
    }
    if (!balls[powerNet].l || !balls[powerNet].r) {
      errors.push(`[Pre-Layout][${name}][${powerNet}][Ball] Not set L or R.`)
    }
  }

  for (let decapGroup of decapGroups) {
    const { l_group, r_group, decaps, name: groupName } = decapGroup;
    if (!l_group || !r_group) {
      errors.push(`[Pre-Layout][${name}][${groupName}] Not set L Group or R Group.`)
    }
    for (let decap of decaps) {
      const { l_layout, model, name: decapName, number, r_layout } = decap;
      if (!l_layout || !r_layout) {
        errors.push(`[Pre-Layout][${name}][${groupName}][${decapName}] Not set L Layout or R Layout.`)
      }
      if (!number) {
        errors.push(`[Pre-Layout][${name}][${groupName}][${decapName}] Not set decap number.`)
      }
      if (!model || !model.subckt) {
        errors.push(`[Pre-Layout][${name}][${groupName}][${decapName}] Not set decap part.`)
      }
      if (decapList) {
        const library = decapList.find(item => item.id === model.libraryId);
        if (!library && model.fileName) {
          errors.push(`[Pre-Layout][${name}][${groupName}][${decapName}] ${model.fileName} can not be found in Library.`)
        }
      }
    }
  }

  return errors
}

async function preLayoutModelErrorCheck(model) {
  const { files = [], ports = [] } = model;
  const errors = [];
  const parsedFileList = [];
  for (let index = 0; index < files.length; index++) {
    const file = files[index];
    const fileInfo = {
      modelKey: file.modelKey,
      fileName: file.fileName,
      libraryId: file.libraryId,
      type: file.type,
      subckt: file.subckt,
      nodes: [],
    };
    if (file.type === SPICE) {
      try {
        const res = await getPkgSpiceModelList(file.libraryId, file.fileName, "SPICE");
        if (res && res.models && Array.isArray(res.models)) {
          const subcktInfo = res.models.find(item => item.name === file.subckt);
          fileInfo.nodes = subcktInfo ? subcktInfo.ports || [] : [];
        }
      } catch (error) {
        console.error(error);
      }
    } else if (file.type === TOUCHSTONE) {
      fileInfo.nodes = getPortByTouchstone(file.fileName);
    }
    parsedFileList.push(fileInfo);
  }

  parsedFileList.forEach(file => {
    const { fileName, libraryId, modelKey, subckt, nodes = [] } = file;
    const usedNodes = new Set();
    ports.forEach(portItem => {
      const { icPorts = [], pmicPorts = [] } = portItem;
      [...icPorts, ...pmicPorts].forEach(p => {
        if (
          p.libraryId === libraryId &&
          p.fileName === fileName &&
          p.modelKey === modelKey &&
          p.subckt === subckt &&
          p.node
        ) {
          usedNodes.add(p.node);
        }
      });
    });

    const unusedNodes = nodes.filter(n => !usedNodes.has(n));
    if (unusedNodes.length > 0) {
      errors.push(`[Pre-Layout][File] ${fileName}::${subckt} has unused nodes: ${unusedNodes.join(', ')}.`)
    }
  });

  if (errors.length > 0) {
    errors.push('Please check Pre-Layout settings to handle the unused nodes, or enable "Use HSPICE for Simulation" in Options.')
  }
  return errors
};

export {
  preLayoutErrorCheck
}